import { Controller } from '@hotwired/stimulus';

// Keeps duplicate picks in sync when the same media file appears twice
// (e.g. "recent" + folder).
export default class extends Controller {
  connect() {
    this.onChange = this.syncFromEvent.bind(this);
    this.onFrameLoad = this.syncAll.bind(this);
    this.element.addEventListener('change', this.onChange);
    this.element.addEventListener('turbo:frame-load', this.onFrameLoad);
    this.syncAll();
  }

  disconnect() {
    this.element.removeEventListener('change', this.onChange);
    this.element.removeEventListener('turbo:frame-load', this.onFrameLoad);
  }

  inputs() {
    return this.element.querySelectorAll('input.image-select__checkbox');
  }

  syncFromEvent(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (!input.classList.contains('image-select__checkbox')) return;

    if (input.type === 'radio') {
      this.inputs().forEach((other) => {
        other.checked = other.value === input.value;
      });
      return;
    }

    this.syncValue(input.value, input.checked);
  }

  syncAll() {
    const checkedValues = new Set();
    this.inputs().forEach((input) => {
      if (input.checked) checkedValues.add(input.value);
    });

    this.inputs().forEach((input) => {
      const shouldCheck = checkedValues.has(input.value);
      if (input.checked !== shouldCheck) input.checked = shouldCheck;
    });
  }

  syncValue(value, checked) {
    this.inputs().forEach((input) => {
      if (input.value !== String(value)) return;
      if (input.checked !== checked) input.checked = checked;
    });
  }
}
